import { weekdays } from "../constants";
import { ShiftDay } from "./ShiftDay";
import { ShiftWeekHeader } from "./ShiftWeekHeader";

const shortenedWeekdays = weekdays.map((weekday) => weekday.substring(0, 3));
const shiftWeekStyle = { paddingInlineStart: "0px" };
const ShiftWeek = ({
  index,
  scheduledHours = 0,
  cases = [],
  shifts = {},
  dolStatus,
  showUpcoming,
}) => {
  const hasVisibleDays = Object.values(shifts).some((dayShifts) => {
  const scheduleTypes = dayShifts?.scheduleTypes || {};

  return Object.values(scheduleTypes).some(
    ({ unassigned = [] }) => unassigned.length > 0
  );
});

if (showUpcoming && !hasVisibleDays) {
  return null;
}
  return (
    <li>
      <ul style={shiftWeekStyle}>
        <ShiftWeekHeader
          scheduledHours={scheduledHours}
          index={index}
          dolStatus={dolStatus}
        />
        {Object.entries(shifts)
          .sort((thisEntry, thatEntry) => {
            const thisIndex = shortenedWeekdays.indexOf(thisEntry[0]);
            const thatIndex = shortenedWeekdays.indexOf(thatEntry[0]);

            if (thisIndex < thatIndex) {
              return -1;
            }

            if (thisIndex > thatIndex) {
              return 1;
            }

            return 0;
          })
          .map(([weekday, shifts]) => {
            return (
              <ShiftDay
                key={weekday}
                cases={cases.filter((c) => c.dayOfWeek === weekday)}
                shifts={shifts}
                weekday={weekday}
                showUpcoming={showUpcoming}
              />
            );
          })}
      </ul>
    </li>
  );
};

export { ShiftWeek };
